<template>
  <div>
    <template v-if="isPopover">
      <el-tooltip placement="top">
        <div slot="content" v-for="(item, index) of currentSelectList" :key="index">{{
          item[labelName]
        }}</div>
        <SelectItem
          v-bind="$attrs"
          v-on="$listeners"
          @input="changeHandler"
          :labelName="labelName"
        />
      </el-tooltip>
    </template>
    <template v-else>
      <SelectItem v-bind="$attrs" v-on="$listeners" @input="changeHandler" :labelName="labelName" />
    </template>
  </div>
</template>

<script>
  import SelectItem from './SelectItem';
  export default {
    name: 'IElSelect',
    props: {
      // 是否有提示
      isPopover: {
        type: Boolean,
        default: false,
      },
      // 是否直接返回选中的值
      isReturnValue: {
        type: Boolean,
        default: true,
      },
      // 显示的字段名
      labelName: {
        type: String,
        default: 'label',
      },
    },
    data() {
      return {
        currentSelectList: [],
      };
    },
    methods: {
      changeHandler(value, currentSelectList) {
        this.currentSelectList = currentSelectList;
        if (this.isReturnValue) {
          this.$emit('input', value);
        } else {
          this.$emit('input', currentSelectList);
        }
      },
    },
    components: {
      SelectItem,
    },
  };
</script>
